import TrailAPI from './trail-api';

export default TrailAPI;
